import { render, staticRenderFns } from "./workExperienceDetail.vue?vue&type=template&id=a2f168b6&scoped=true&"
import script from "./workExperienceDetail.vue?vue&type=script&lang=js&"
export * from "./workExperienceDetail.vue?vue&type=script&lang=js&"
import style0 from "./workExperienceDetail.vue?vue&type=style&index=0&id=a2f168b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f168b6",
  null
  
)

export default component.exports